import { useContext, useEffect, useMemo, useRef, useState } from "react";
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { DateTime } from "luxon";
import { decryptData } from "../../../utils/encrypt";
import { dateConvert } from "../../../utils/Helper";
import projectStore from "../../../Store/projectStore";

export const useProfile = ({ userFromWidget }) => {

    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const [selectedTimezone, setSelectedTimezone] = useState();
    const [selectedEmployee, setSelectedEmployee] = useState({});
    const [option, setOption] = useState({});
    const [visible, setVisible] = useState({ reset_pwd: false, project_change: false, user_group: false, });
    const [profileData, setProfileData] = useState({});
    const [selectedData, setSelectedData] = useState({ session: [], view_user_group: false, view_user_group_api: false, notification: { is_notification_enable: false, is_timesheet_notification: false, is_unpunctuality_notification: false }, notification_api_data: { is_notification_enable: false, is_timesheet_notification: false, is_unpunctuality_notification: false } });
    const [loggedInUser, setLoggedInUser] = useState({ user: {}, user_info: {} });
    const [loader, setLoader] = useState(false);
    const [isChanged, setIsChanged] = useState(false);
    const tagref = useRef();
    const [callAutopop, setCallAutopop] = useState(false);
    const [formValues, setFormValues] = useState({ primaryProject: "", isChange: false })
    // const { getProjectModule } = projectStore()


    useEffect(() => {
        callAutopop && sessionStorage.removeItem("user_info");
        callautopopulate("users", "user_info", "day_calendar_timezone", "project_leads", "projects", "user_technologies", "user_attributes_request_types").then(res => {
            const users = (res?.users)?.map((item) => { return { ...item, user_display_name: item?.user_display_location_name } })?.sort((a, b) => a?.user_display_name?.localeCompare(b?.user_display_name));
            const selectedEmp = !_.isEmpty(userFromWidget) ? _.find(users, { user_code: userFromWidget?.user_code }) : _.find(users, { user_code: res?.user_info?.[0]?.user_code });
            setSelectedEmployee(selectedEmp);
            setOption({
                timezoneOption: res?.day_calendar_timezone,
                userOption: users, userCode: res?.user_info?.[0]?.user_code,
                projectOpt: _.sortBy(res?.projects, "project_name")?.map((item) => ({
                    ...item,
                    requested_name: item?.project_name,
                    attribute_type_id: _.find(res?.user_attributes_request_types, { attribute_key: "primary_project" })?.attribute_type_id,
                })),
                technologiesOpt: _.sortBy(res?.user_technologies, 'primary_skill_1')?.map((item) => ({
                    ...item,
                    requested_name: item?.primary_skill_1,
                    attribute_type_id: _.find(res?.user_attributes_request_types, { attribute_key: "primary_tech" })?.attribute_type_id,
                })),
                apiCall: true,

            })
            setSelectedTimezone(_.find(res?.day_calendar_timezone, { timezone_id: profileData?.user_details?.[0]?.timezone_id }))
            setLoggedInUser({ user: _.find(users, { user_code: res?.user_info?.[0]?.user_code }), user_info: res?.user_info?.[0] });
            setSelectedData((prev) => ({ ...prev, view_user_group_api: res?.user_info?.[0]?.is_user_grouping_view, view_user_group: res?.user_info?.[0]?.is_user_grouping_view || false }));
            setCallAutopop(false);
        });
    }, [callAutopop]);

    useEffect(() => {
        option?.apiCall && getProfileInfo(selectedEmployee?.user_code);
    }, [option?.apiCall])


    const getProfileInfo = async (userCode) => {
        try {
            setSelectedData((prev) => ({ ...prev, session: [] }));
            setLoader(true);
            const payload = {
                requested_user_code: userCode ? userCode : selectedEmployee?.user_code
            }
            const res = await services.getInvokeRemote("POST", Urls("GETUSERPROFILEINFO"), payload);
            if (res) {
                const data = res?.body?.data;
                const token = decryptData(sessionStorage.getItem("token"));
                const currentSession = _.findWhere(data?.active_sessions_details, { token: token?.split(" ")?.[1] });
                data?.active_sessions_details?.map(item => item["is_current_session"] = item?.token_id === currentSession?.token_id);
                setProfileData(data);
                const primaryProject = _.find(option?.projectOpt, (item) =>
                    item?.project_name?.toLowerCase() === data?.user_details[0]?.primary_project?.toLowerCase()
                )
                const primarySkill = _.find(option?.technologiesOpt, (item) =>
                    item?.primary_skill_1?.toLowerCase() === data?.user_details[0]?.primary_skill_1?.toLowerCase()
                )

                setFormValues((prev) => ({
                    ...prev,
                    primaryProject: { value: { ...primaryProject }, isChange: false },
                    technologie: { value: { ...primarySkill }, isChange: false }
                }));
                // getProjectModule(primaryProject?.project_id)
                tableData?.notification_details?.forEach((item) => {
                    setSelectedData((prev) => ({ ...prev, notification: { ...prev.notification, [item?.key]: data?.user_details?.[0]?.[item?.key] }, notification_api_data: { ...prev.notification, [item?.key]: data?.user_details?.[0]?.[item?.key] } }));
                })

                setLoader(false);
            }
        } catch (error) {
            console.error("Error: ", error);
            setLoader(false);
        }
    }

    const upsertUserUnitTimezone = async (id) => {
        try {
            const payload = {
                "timezone_id": id?.timezone_id,
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSERTIMEZONE"), payload);
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
            } else {
                showError("error", res?.body?.message);
            }

        } catch (error) {
            console.error(error)
        }
    }

    const upsertUserNotification = async (group) => {
        try {
            if ((_.isEqual(selectedData?.notification, selectedData?.notification_api_data) && !group) || (group && selectedData?.view_user_group === selectedData?.view_user_group_api)) {
                showInfo("Info", "No changes made!");
                return;
            }
            const payload = {
                "is_notification": selectedData?.notification?.is_notification_enable || false,
                "is_timesheet_notification": selectedData?.notification?.is_timesheet_notification || false,
                "is_unpunctuality_notification": selectedData?.notification?.is_unpunctuality_notification || false,
                "is_user_grouping_view": group ? selectedData?.view_user_group : false
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSERNOTIFICATION"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                setSelectedData((prev) => ({ ...prev, notification_api_data: selectedData?.notification }));
                group && setCallAutopop(true);
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const handleLogout = async (logoutAll) => {
        try {
            if (!logoutAll && _.isEmpty(selectedData?.session)) {
                showInfo("Info", "Please select session to logout");
                return;
            }
            const payloadSession = !logoutAll ? selectedData?.session : _.filter(profileData?.active_sessions_details, item => !item?.is_current_session) || [];
            const payload = {
                token_ids: _.pluck(payloadSession, "token_id")?.toString() || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSERDEVICESLOGOUT"), payload);
            if (res?.body?.StatusCode === 202) {
                showError("Error", res?.body?.errorMessage);
            } else {
                showSuccess("Success", res?.body?.message);
                getProfileInfo();
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }
    const tableData = {
        employee_details: [
            { label: "Employee ID", value: profileData?.user_details?.[0]?.employee_id || "-" },
            { label: "Business Unit", value: profileData?.user_details?.[0]?.business_unit || "-" },
            { label: "SBU", value: profileData?.user_details?.[0]?.sub_business_unit || "-", title: "Sub Business Unit" },
            {
                label: "Join", value: (
                    <>
                        {profileData?.user_details?.[0]?.joining_date && (DateTime.fromISO(profileData?.user_details?.[0]?.joining_date).toFormat('dd LLL yyyy') || "-")} {profileData?.user_details?.[0]?.tenure && `(${profileData?.user_details?.[0]?.tenure})`}
                    </>
                )
            },
            {
                label: "Confirmation Date", value: (
                    <>
                        {profileData?.user_details?.[0]?.confirmation_date && (DateTime.fromISO(profileData?.user_details?.[0]?.confirmation_date).toFormat('dd LLL yyyy') || "-")}
                    </>
                )
            },
            {
                label: "Locations", value: profileData?.user_details?.[0]?.locations || "-"
            }
        ],
        project_tech_details: [
            { label: "Primary Project", value: profileData?.user_details?.[0]?.primary_project || "-" },
            { label: "Sec. Project", value: profileData?.user_details?.[0]?.secondary_project || "-" },
            { label: "Primary Tech", value: profileData?.user_details?.[0]?.primary_skill_1 || "-" },
            { label: "Secondary Tech", value: profileData?.user_details?.[0]?.secondary_skill_1 || "-" },
        ],
        notification_details: [
            { label: "Browser Notification", key: "is_notification_enable" },
            { label: "Timesheet Notification", key: "is_timesheet_notification" },
            { label: "Unpunctuality Notification", key: "is_unpunctuality_notification" },
        ],
    };

    const tableCols = {
        active_session: [
            { field: "device_name", header: "Device" },
            { field: "ip_address_name", header: "IP" },
            { field: "token_generate_datetime", header: "Last Access" },
            { field: "is_active", header: "Status" },
        ],
        shift: [
            { field: "group_name", header: "Shift Name" },
            { field: "effective_start_date", header: "Start Date" },
            { field: "effective_end_date", header: "End Date" }
        ]
    }

    const sessionBodyTemplate = (rowdata, col) => {
        return (
            <div className={(col?.field === "is_active" && rowdata?.[col?.field]) ? "text-success" : ""}>
                {col?.field === "token_generate_datetime" ? dateConvert(rowdata?.[col?.field], "date-time-months") : (col?.field === "is_active" ? (rowdata?.[col?.field] ? `Active ${rowdata?.is_current_session ? "(Current)" : ""}` : "Expired") : rowdata?.[col?.field])}
            </div>
        )
    }


    const upsertProfile = async () => {
        try {
            const data = []
            Object.keys(formValues)?.forEach((key) => {
                if (!formValues[key]?.isChange) { return }
                data.push({
                    requested_name: formValues[key]?.value.requested_name,
                    attribute_type_id: formValues[key]?.value?.attribute_type_id
                })
            })
            if (data?.length === 0) {
                showInfo("info", "No changes to submit");
                return;
            }
            const payload = { "attributes_request": data };
            const res = await services.getInvokeRemote("POST", Urls("UPSERTUSERATTRIBUTESREQUEST"), payload);
            if (!res.body.error_status) {
                showSuccess("Success", res?.body?.message);
                setVisible((prev) => ({ ...prev, project_change: false, isChange: false }));
                const primaryProject = _.find(option?.projectOpt, (item) => item?.project_name?.toLowerCase() === profileData?.user_details[0]?.primary_project?.toLowerCase())
                const primarySkill = _.find(option?.technologiesOpt, (item) => item?.primary_skill_1?.toLowerCase() === profileData?.user_details[0]?.primary_skill_1?.toLowerCase())
                setFormValues((prev) => ({
                    ...prev,
                    isChange: false,
                    primaryProject: { value: { ...primaryProject }, isChange: false },
                    technologie: { value: { ...primarySkill }, isChange: false }
                }));
            } else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error("Submission error:", error);
              showError("Error", error?.response?.data?.errorMessage);
        }
    };

    return useMemo(() => ({
        selectedTimezone, setSelectedTimezone, selectedEmployee, setSelectedEmployee, option, upsertUserUnitTimezone, tableData, tableCols, loader, getProfileInfo, loggedInUser, profileData, selectedData, setSelectedData, isChanged, setIsChanged, upsertUserNotification, handleLogout, sessionBodyTemplate, tagref, visible, setVisible, formValues, setFormValues, upsertProfile
    }), [selectedTimezone, setSelectedTimezone, selectedEmployee, setSelectedEmployee, option, upsertUserUnitTimezone, tableData, tableCols, loader, getProfileInfo, loggedInUser, profileData, selectedData, setSelectedData, isChanged, setIsChanged, upsertUserNotification, handleLogout, sessionBodyTemplate, tagref, visible, setVisible, formValues, setFormValues, upsertProfile]);
}